import { ImpersonationPicker, useSlideLayout } from '@gripp/shared-ui';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export const ImpersonationWorkspaceColumn = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { setColumnTitle } = useSlideLayout();

  useEffect(() => {
    setColumnTitle(t('impersonation.picker.workspaceTitle'));
    return () => setColumnTitle(undefined);
  }, [setColumnTitle, t]);

  const onSave = () =>
    navigate('/settings/impersonation/user', { replace: true });

  return (
    <ImpersonationPicker
      mode="workspace"
      onSave={onSave}
      onOpenFilters={() =>
        navigate('/settings/impersonation/workspace/filters')
      }
    />
  );
};
